import React from 'react';
import { Button } from 'react-bootstrap';
import { EditMaclModal } from '~/components/Admin';
import { MaclType } from '../../Edit/MaclForm';

interface MaclRowProps {
    macl: MaclType;
}
export function MaclRow({ macl }: MaclRowProps) {
    const [showEditMaclModal, setShowEditMaclModal] = React.useState(false);

    return (
        <tr>
            <td>
                <button
                    className="link-button"
                    type="button"
                    onClick={() => setShowEditMaclModal(true)}
                >
                    {macl.name}
                </button>
            </td>
            <td>{`${macl.patients_count}`}</td>
            <td className="p-0 align-middle text-center">
                <Button
                    variant="default"
                    size="sm"
                    onClick={() => setShowEditMaclModal(true)}
                    aria-label="Edit MACL"
                >
                    <i className="fa-solid fa-edit" />
                </Button>
                <EditMaclModal
                    macl={macl}
                    show={showEditMaclModal}
                    setShow={setShowEditMaclModal}
                />
            </td>
        </tr>
    );
}
